module.exports = __webpack_public_path__ + "static/media/build_orbit.8c43c135.svg";